import { combineReducers } from 'redux'

import responsiveReducer from '../global/slices/Responsive'
import dataWebsiteReducer from './dataWebsite/reducer'
import authReducer from './auth/reducer'

import shopReducer from './shop/reducer'

/**
 * Root reducer
 * @type {Reducer<any> | Reducer<any, AnyAction>}
 */
const rootReducers = combineReducers({
  authReducer: authReducer,
  responsive: responsiveReducer,
  dataWebsiteReducer: dataWebsiteReducer,
  shop: shopReducer,
})

export default rootReducers
